import BlockModel from '@wre/infinity-generators/SchemeOfLearning/Year5/Spring/MultiplicationAndDivisionB/index';
import { newBlockContent } from '../../../Block';
import { newSmallStepContent } from '../../../SmallStep';

const Block = newBlockContent({
  block: 'MultiplicationAndDivisionB',
  field: 'Number',
  weeks: [1, 3],
  smallSteps: [
    // Step 1
    newSmallStepContent({
      ...BlockModel.smallSteps[0],
      module: () =>
        import(
          /* webpackChunkName: "Year5/Spring/MultiplicationAndDivisionB/1MultiplyUpToA4DigitNumberByA1DigitNumber" */ './1MultiplyUpToA4DigitNumberByA1DigitNumber'
        )
    }),
    // Step 2
    newSmallStepContent({
      ...BlockModel.smallSteps[1],
      module: () =>
        import(
          /* webpackChunkName: "Year5/Spring/MultiplicationAndDivisionB/2MultiplyA2DigitNumberByA2DigitNumberAreaModel" */ './2MultiplyA2DigitNumberByA2DigitNumberAreaModel'
        )
    }),
    // Step 3
    newSmallStepContent({
      ...BlockModel.smallSteps[2],
      module: () =>
        import(
          /* webpackChunkName: "Year5/Spring/MultiplicationAndDivisionB/3MultiplyA2DigitNumberByA2DigitNumber" */ './3MultiplyA2DigitNumberByA2DigitNumber'
        )
    }),
    // Step 4
    newSmallStepContent({
      ...BlockModel.smallSteps[3],
      module: () =>
        import(
          /* webpackChunkName: "Year5/Spring/MultiplicationAndDivisionB/4MultiplyA3DigitNumberByA2DigitNumber" */ './4MultiplyA3DigitNumberByA2DigitNumber'
        )
    }),
    // Step 5
    newSmallStepContent({
      ...BlockModel.smallSteps[4],
      module: () =>
        import(
          /* webpackChunkName: "Year5/Spring/MultiplicationAndDivisionB/5MultiplyA4DigitNumberByA2DigitNumber" */ './5MultiplyA4DigitNumberByA2DigitNumber'
        )
    }),
    // Step 6
    newSmallStepContent({
      ...BlockModel.smallSteps[5],
      module: () =>
        import(
          /* webpackChunkName: "Year5/Spring/MultiplicationAndDivisionB/6SolveProblemsWithMultiplication" */ './6SolveProblemsWithMultiplication'
        )
    }),
    // Step 7
    newSmallStepContent({
      ...BlockModel.smallSteps[6],
      module: () =>
        import(
          /* webpackChunkName: "Year5/Spring/MultiplicationAndDivisionB/7ShortDivision" */ './7ShortDivision'
        )
    }),
    // Step 8
    newSmallStepContent({
      ...BlockModel.smallSteps[7],
      module: () =>
        import(
          /* webpackChunkName: "Year5/Spring/MultiplicationAndDivisionB/8DivideA4DigitNumberByA1DigitNumber" */ './8DivideA4DigitNumberByA1DigitNumber'
        )
    }),
    // Step 9
    newSmallStepContent({
      ...BlockModel.smallSteps[8],
      module: () =>
        import(
          /* webpackChunkName: "Year5/Spring/MultiplicationAndDivisionB/9DivideWithRemainders" */ './9DivideWithRemainders'
        )
    }),
    // Step 10
    newSmallStepContent({
      ...BlockModel.smallSteps[9],
      module: () =>
        import(
          /* webpackChunkName: "Year5/Spring/MultiplicationAndDivisionB/10EfficientDivision" */ './10EfficientDivision'
        )
    }),
    // Step 11
    newSmallStepContent({
      ...BlockModel.smallSteps[10],
      module: () =>
        import(
          /* webpackChunkName: "Year5/Spring/MultiplicationAndDivisionB/11SolveProblemsWithMultiplicationAndDivision" */ './11SolveProblemsWithMultiplicationAndDivision'
        )
    })
  ]
});
export default Block;
